module.exports = __webpack_public_path__ + "img/B.5c5dd0b1.png";